import { MTRuleSettingTable } from './MTRuleSettingTable'

/**
 * MTRuleSettingPage - Renders the Rule Setting table component for multi-territory.
 */
export function MTRuleSettingPage() {
  return <MTRuleSettingTable />
}
